"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeMap = void 0;
var tslib_1 = require("tslib");
/**
 * Simple map implementation that is the same as native Map.
 *
 * IE11 Map is not used because it has inconsistencies with other browsers.
 */
var IkeMap = /** @class */ (function () {
    function IkeMap() {
        this._values = {};
    }
    IkeMap.prototype.get = function (key) {
        return this._values[key];
    };
    IkeMap.prototype.set = function (key, value) {
        this._values[key] = value;
    };
    IkeMap.prototype.has = function (key) {
        return this._values[key] != null;
    };
    IkeMap.prototype.keys = function () {
        return Object.keys(this._values);
    };
    IkeMap.prototype.values = function () {
        var e_1, _a;
        var keys = Object.keys(this._values);
        var output = [];
        try {
            for (var keys_1 = tslib_1.__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                output.push(this._values[key]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return output;
    };
    IkeMap.prototype.clear = function () {
        this._values = {};
    };
    IkeMap.prototype.delete = function (key) {
        delete this._values[key];
    };
    Object.defineProperty(IkeMap.prototype, "size", {
        get: function () {
            return this.keys().length;
        },
        enumerable: false,
        configurable: true
    });
    return IkeMap;
}());
exports.IkeMap = IkeMap;
//# sourceMappingURL=ike.map.js.map